import { ErrorHandler, inject, Injectable, isDevMode, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
    private readonly sentryHandler = Sentry.createErrorHandler();
    private readonly router = inject(Router);
    private readonly platformId = inject(PLATFORM_ID);

    handleError(error: unknown): void {
        this.sentryHandler.handleError(error);

        // In dev, let the error surface (console + overlay) instead of hiding it behind /error.
        if (isDevMode() || !isPlatformBrowser(this.platformId) || this.router.url.startsWith('/error')) return;

        this.router.navigateByUrl('/error');
    }
}
